export const platformAccess = {
  junior: {
    required: [
      { platform: 'Figma', access: 'Viewer', purpose: 'Design review and prototype testing', setup: 'Request viewer access to design files and prototypes' },
      { platform: 'Slack', access: 'Member', purpose: 'Research team communication', setup: 'Join #ux-research, #design-team, #product-team channels' },
      { platform: 'Zoom', access: 'Pro', purpose: 'User interviews and usability testing', setup: 'Request Zoom Pro license for recording capabilities' },
      { platform: 'Google Workspace', access: 'Editor', purpose: 'Survey creation and data collection', setup: 'Request access to Forms, Sheets, and Drive' }
    ],
    optional: [
      { platform: 'UserTesting', access: 'Researcher', purpose: 'Remote usability testing', setup: 'Request researcher account for user testing platform' },
      { platform: 'Hotjar', access: 'Viewer', purpose: 'Heatmap and session recording analysis', setup: 'Request viewer access to analytics data' }
    ]
  },
  mid: {
    required: [
      { platform: 'Dovetail', access: 'Editor', purpose: 'Research repository and insight management', setup: 'Request editor access to research workspace' },
      { platform: 'Maze', access: 'Researcher', purpose: 'Usability testing and user journey analysis', setup: 'Request researcher account with test creation permissions' },
      { platform: 'Amplitude', access: 'Analyst', purpose: 'Product analytics and behavioral data', setup: 'Request analyst access to product analytics dashboard' },
      { platform: 'Airtable', access: 'Creator', purpose: 'Research data management and tracking', setup: 'Request creator permissions for database management' }
    ],
    optional: [
      { platform: 'Tableau', access: 'Creator', purpose: 'Advanced data visualization', setup: 'Request Tableau Creator license for dashboard creation' },
      { platform: 'Optimal Workshop', access: 'Researcher', purpose: 'Information architecture testing', setup: 'Request researcher account for IA testing tools' }
    ]
  },
  senior: {
    required: [
      { platform: 'Research Operations Platform', access: 'Admin', purpose: 'Enterprise research management', setup: 'Request admin access to research operations tools' },
      { platform: 'Advanced Analytics Suite', access: 'Admin', purpose: 'Complex data analysis and modeling', setup: 'Request admin access to enterprise analytics platform' },
      { platform: 'AI Research Tools', access: 'Admin', purpose: 'AI-powered research analysis', setup: 'Request admin access to AI research and automation tools' },
      { platform: 'Enterprise Survey Platform', access: 'Admin', purpose: 'Large-scale research studies', setup: 'Request admin access to enterprise survey and panel management' }
    ],
    optional: [
      { platform: 'Machine Learning Platform', access: 'Data Scientist', purpose: 'Predictive analytics and modeling', setup: 'Request data scientist access to ML platforms' },
      { platform: 'Big Data Analytics', access: 'Analyst', purpose: 'Large dataset analysis', setup: 'Request analyst access to big data processing tools' }
    ]
  }
};
